"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _filters = require("../../config/filters");
var _utils = require("../utils");
var _CustomFieldAdder = require("./CustomFieldAdder");
var _CustomFieldConditions = _interopRequireDefault(require("./CustomFieldConditions/CustomFieldConditions"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var styles = {
  "dropdown": "dropdown_1l8WRz",
  "dropdown-header": "dropdown-header_seOCk7",
  "dropdownHeader": "dropdown-header_seOCk7",
  "dropdown-content": "dropdown-content_1UKvfw",
  "dropdownContent": "dropdown-content_1UKvfw",
  "dropdown-list": "dropdown-list_2uZlLH",
  "dropdownList": "dropdown-list_2uZlLH",
  "dropdown-list-item": "dropdown-list-item_12ZGQu",
  "dropdownListItem": "dropdown-list-item_12ZGQu",
  "clickable-list-item": "clickable-list-item_1YbC3A",
  "clickableListItem": "clickable-list-item_1YbC3A",
  "list-item-label": "list-item-label_hFHfI6",
  "listItemLabel": "list-item-label_hFHfI6",
  "list-item-description": "list-item-description_3qdXQW",
  "listItemDescription": "list-item-description_3qdXQW",
  "dropdown-footer": "dropdown-footer_KV5yC0",
  "dropdownFooter": "dropdown-footer_KV5yC0",
  "dropdown-footer-actions": "dropdown-footer-actions_u1XyHM",
  "dropdownFooterActions": "dropdown-footer-actions_u1XyHM"
}; 
require('./CustomFieldsConditionsEditor.css');
const CustomFieldsConditionsEditor = ({
  options,
  onSearch,
  onChange,
  onClear,
  onSubmit,
  value: selectedFilters = [],
  id
}) => {
  const [activeItemIndex, setActiveItemIndex] = (0, _react.useState)(selectedFilters.length - 1);
  const wrapperRef = (0, _react.useRef)();
  const itemsRefs = (0, _react.useMemo)(() => Array(selectedFilters.length).fill(0).map(() => /*#__PURE__*/(0, _react.createRef)()), [selectedFilters.length]);
  (0, _react.useEffect)(() => {
    var _itemsRefs$activeItem, _ref$current;
    const ref = (_itemsRefs$activeItem = itemsRefs[activeItemIndex]) !== null && _itemsRefs$activeItem !== void 0 ? _itemsRefs$activeItem : wrapperRef;
    ref === null || ref === void 0 || (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
  }, [activeItemIndex, itemsRefs]);
  const addFilter = (0, _react.useCallback)(customField => {
    setActiveItemIndex(selectedFilters.length);
    onChange === null || onChange === void 0 || onChange([...selectedFilters, {
      customField,
      operator: _filters.CUSTOM_FIELDS_OPERATORS_MAPPING[customField.dataType][0]
    }]);
  }, [onChange, selectedFilters]);
  const removeFilter = (0, _react.useCallback)((filter, removedIndex) => {
    /**
     * If the user removes the first filter and others remain,
     * the focus should go to the first remaining filter.
     * In any other case, the focus should go to the previous filter
     * (or the component wrapper).
     */
    setActiveItemIndex(removedIndex === 0 && selectedFilters.length > 1 ? 0 : removedIndex - 1);
    onChange === null || onChange === void 0 || onChange(selectedFilters.filter(selectedFilter => selectedFilter !== filter));
  }, [onChange, selectedFilters]);
  const updateFilter = (0, _react.useCallback)((updatedFilter, updatedIndex) => onChange === null || onChange === void 0 ? void 0 : onChange(selectedFilters.map((selectedFilter, index) => index === updatedIndex ? updatedFilter : selectedFilter)), [onChange, selectedFilters]);
  const handleClear = (0, _react.useCallback)(() => {
    onChange === null || onChange === void 0 || onChange([]);
    onClear === null || onClear === void 0 || onClear();
    setActiveItemIndex(-1);
  }, [onChange, onClear]);
  const handleApply = (0, _react.useCallback)(() => {
    onSubmit === null || onSubmit === void 0 || onSubmit(selectedFilters.filter(_utils.filterHasNoEmptyConditions));
  }, [selectedFilters, onSubmit]);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "custom-fields-conditions-editor",
    className: styles.dropdown,
    ref: wrapperRef,
    id: id,
    role: "listbox",
    tabIndex: -1
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: styles.dropdownContent
  }, selectedFilters.map((filter, index) => /*#__PURE__*/_react.default.createElement(_CustomFieldConditions.default, {
    key: `${filter.customField.tagKey}-${index}`,
    filter: filter,
    ref: itemsRefs[index],
    onRemove: removedFilter => removeFilter(removedFilter, index),
    onChange: updatedFilter => updateFilter(updatedFilter, index)
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.dropdownFooter
  }, /*#__PURE__*/_react.default.createElement(_CustomFieldAdder.CustomFieldAdder, {
    onSearch: onSearch,
    options: options,
    onCustomFieldSelected: addFilter
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: styles.dropdownFooterActions
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    kind: "tertiary",
    onClick: handleClear
  }, "Clear filter"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    kind: "secondary",
    onClick: handleApply
  }, "Apply"))));
};
var _default = exports.default = CustomFieldsConditionsEditor;
//# sourceMappingURL=CustomFieldsConditionsEditor.js.map